import {
    EditableEntity,
    IEditableEntity,
    IPropEventBroker,
    IReadablePropEventBroker,
} from '@zdrbm/zdr-native-tools';
import { IDrawerController } from '../drawer/DrawerController';

export enum PanelTypes {
    History = 'History',
    Conversation = 'Conversation',
    NewConversation = 'NewConversation',
}

export interface IAssistantUiManager extends IEditableEntity {
    toggleHistory(): void;
    createNewChat(): void;
    openConversation(conversationId: string): void;
    closeAssistantPanel(): void;
    currentPanel: IReadablePropEventBroker<PanelTypes>;
    currentConversation: IReadablePropEventBroker<string | undefined>;
}

export class AssistantUiManager
    extends EditableEntity<keyof IAssistantUiManager>
    implements IAssistantUiManager
{
    currentPanel: IPropEventBroker<PanelTypes>;
    currentConversation: IPropEventBroker<string | undefined>;

    constructor(private drawerController: IDrawerController) {
        super(undefined);
        this.currentPanel = this.createPropEventBroker('currentPanel', PanelTypes.NewConversation);
        this.currentConversation = this.createPropEventBroker('currentConversation', undefined);
    }

    closeAssistantPanel(): void {
        this.drawerController.closeDrawer();
    }

    openConversation(conversationId: string): void {
        this.currentConversation.set(conversationId);
        this.currentPanel.set(PanelTypes.Conversation);
    }

    toggleHistory(): void {
      const current = this.currentPanel.get();
      const currentConversation = this.currentConversation.get();
      if (current === PanelTypes.History && currentConversation) {
          this.currentPanel.set(PanelTypes.Conversation);
      } else if (current === PanelTypes.History) {
          this.currentPanel.set(PanelTypes.NewConversation);
      } else {
          this.currentPanel.set(PanelTypes.History);
      }
    }

    createNewChat(): void {
        this.currentConversation.set(undefined);
        this.currentPanel.set(PanelTypes.NewConversation);
    }

    getEntityName(): string {
        return 'AssistantUiManager';
    }
}
